import { requester } from '../utils';

export const getMyCafeDailyWorkingHours = _ => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/working-hour/my-cafe-daily'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getMyRseeDailyWorkingHours = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/working-hour/cafe-daily/${id}`
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
